import { render } from "./Fremdleitung.vue?vue&type=template&id=722fdeb4&scoped=true&ts=true"
import script from "./Fremdleitung.vue?vue&type=script&lang=ts"
export * from "./Fremdleitung.vue?vue&type=script&lang=ts"

import "./Fremdleitung.vue?vue&type=style&index=0&id=722fdeb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722fdeb4"]])

export default __exports__